import React from "react";
import Button from "../common/Button";

const BrandFeatureCard = ({
  cardImage,
  cardImageSize = "h-48 w-full object-cover sm:h-56 md:h-64 lg:h-72 2xl:h-[339px]",
  headingIcon,
  title,
  subText,
  pClassName,
  btnpadding = "py-6 sm:py-8 2xl:pt-11 2xl:pb-10",
}) => {
  return (
    <div className="flex h-full min-w-0 flex-col overflow-hidden shadow-[0px_21px_8.8px_-6px_#0000004F]">
      <img
        src={cardImage}
        alt={title || "feature"}
        className={cardImageSize}
      />
      <div className="mt-4 flex items-center gap-3 px-3 sm:mt-6 sm:px-4 2xl:mt-9 2xl:pl-[30px]">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#923D8C] sm:h-12 sm:w-12 2xl:h-[61px] 2xl:w-[61px]">
          <img
            src={headingIcon}
            className="h-6 w-6 sm:h-8 sm:w-8 2xl:h-10 2xl:w-10"
            alt=""
          />
        </div>
        <h2 className="min-w-0 text-lg font-bold leading-snug text-black sm:text-xl sm:leading-5 2xl:text-2xl 2xl:leading-7">
          {title}
        </h2>
      </div>

      <p
        className={`${pClassName} max-w-full flex-1 px-3 text-base font-normal leading-6 text-black sm:px-4 sm:text-lg sm:leading-5 2xl:pl-[30px] 2xl:pr-[29px] 2xl:text-xl 2xl:leading-[23px]`}
      >
        {subText}
      </p>
      <div className={`px-3 sm:px-6 2xl:px-[30px] ${btnpadding}`}>
        <Button
          btnClassName="w-full rounded-full border border-[#923D8C] bg-[#923D8C] py-2.5 text-base font-bold leading-5 text-white hover:bg-white hover:text-[#923D8C] sm:py-3 sm:text-lg 2xl:py-4 2xl:text-xl 2xl:leading-[23px]"
          btnText="See More"
        />
      </div>
    </div>
  );
};

export default BrandFeatureCard;
